import { useCallback } from "react";

// SVG and stitch history must advance together, including a live picker drag.
export default function useLayerColorHistory(updateSvg, pushSvgColorMarker) {
  return useCallback((layerIdx, newColor, historyGroup) => {
    if (!Number.isInteger(layerIdx) || !newColor || !updateSvg) return;
    let next;
    updateSvg((prev) => {
      const layer = prev?.children?.[layerIdx];
      if (!layer || layer.attributes?.fill?.toLowerCase() === newColor.toLowerCase()) return null;
      const children = [...prev.children];
      children[layerIdx] = { ...layer, attributes: { ...layer.attributes, fill: newColor } };
      next = { ...prev, children };
      return null;
    });
    if (!next) return;
    const replaceHistory = pushSvgColorMarker?.(layerIdx, historyGroup) || false;
    updateSvg(next, { replaceHistory });
  }, [updateSvg, pushSvgColorMarker]);
}
